import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div\n  class={{cn \"card-pay-field-stack\" card-pay-field-stack--is-horizontal=@horizontal}}\n  ...attributes\n>\n  {{yield}}\n</div>")